export default "__VITE_ASSET__5779b88b__"